import type { OfflineBundle } from "../../types";
import { EsploraClient } from "../../verify/esplora";
import { runPipeline } from "../../verify/pipeline";
import type { UiState } from "../render";

export interface OfflineViewDeps {
  esploraBaseUrls: string[];
}

export async function loadOfflineFromBundle(
  bundle: OfflineBundle,
  deps: OfflineViewDeps,
): Promise<UiState> {
  const esplora = new EsploraClient(deps.esploraBaseUrls);
  const result = await runPipeline(bundle, { esplora });
  const state: UiState = { kind: "offline-result", result };
  if (bundle.ots_proof_b64) {
    state.download = { proofBase64: bundle.ots_proof_b64 };
  }
  return state;
}

export function readBundleFromFile(file: File): Promise<OfflineBundle> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error ?? new Error("file read failed"));
    reader.onload = () => {
      try {
        const text = reader.result as string;
        const parsed = JSON.parse(text) as OfflineBundle;
        if (!parsed.envelope || !parsed.signature || !parsed.sigil_public_key_b64) {
          reject(new Error("bundle missing required fields"));
          return;
        }
        resolve(parsed);
      } catch (e) {
        reject(e instanceof Error ? e : new Error(String(e)));
      }
    };
    reader.readAsText(file);
  });
}
